<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Colegios</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <v-text-field
      v-model="buscar"
      label="Buscar"
      single-line
      hide-details
      @change="actualizar()"
    ></v-text-field>
    <v-btn text icon @click="actualizar()">
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn color="primary" dark class="mb-2" v-on:click="nuevoRegistro()">Nuevo colegio</v-btn>
    <v-dialog v-model="dialog" max-width="550px">
      <v-card>
        <v-card-title>
          <span class="headline">Colegio</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-text-field label="Colegio" name="colegio_insc" id="colegio_insc" v-model="registro.nombre" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.nombre = registro.nombre.toUpperCase();"/>
            <v-select label="Tipo de colegio" name="tipo_colegio" id="tipo_colegio" :items="tiposColegio" v-model="registro.tipo" v-bind:disabled="disabledRegistro" item-text="nombre" item-value="id" />
            <v-text-field label="Dirección" name="direccion" id="direccion" v-model="registro.direccion" v-bind:readonly="disabledRegistro" v-on:keyup="registro.direccion = registro.direccion.toUpperCase();"/>
            <v-text-field label="RUC" name="ruc" id="ruc" v-model="registro.ruc" mask="###########" v-bind:readonly="disabledRegistro"/>
            <v-text-field label="Responsable - Apellido Paterno" name="apellido_paterno" id="apellido_paterno" v-model="registro.asesorApellido1" v-bind:readonly="disabledRegistro" v-on:keyup="registro.asesorApellido1 = registro.asesorApellido1.toUpperCase();"/>
            <v-text-field label="Responsable - Apellido materno" name="apellido_materno" id="apellido_materno" v-model="registro.asesorApellido2" v-bind:readonly="disabledRegistro" v-on:keyup="registro.asesorApellido2 = registro.asesorApellido2.toUpperCase();"/>
            <v-text-field label="Responsable - Nombres" name="nombres" id="nombres" v-model="registro.asesorNombres" v-bind:readonly="disabledRegistro" v-on:keyup="registro.asesorNombres = registro.asesorNombres.toUpperCase();"/>
            <v-text-field label="Responsable - DNI" name="dni" id="dni" v-model="registro.asesorDNI" mask="########" v-bind:readonly="disabledRegistro"/>
            <v-text-field label="Teléfono" name="telefono" id="telefono" v-model="registro.telefono" mask="#########" v-bind:readonly="disabledRegistro"/>
            <v-text-field label="Correo electrónico" name="correo" id="correo" v-model="registro.correo" v-bind:readonly="disabledRegistro" v-on:keyup="registro.correo = registro.correo.toUpperCase();"/>
            <v-select label="Sede" name="sede" id="sede" v-model="registro.sede" :items="sedes" item-text="nombre" item-value="id" v-bind:readonly="disabledRegistro" />
            <v-text-field label="Código" name="codigo" mask="########" id="codigo" v-model="registro.codigo" v-bind:readonly="disabledRegistro"/>
            <v-text-field label="Clave" name="clave" id="clave" v-model="registro.clave" v-bind:readonly="disabledRegistro"/>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="eliminarRegistro" v-if="disabledRegistro && usuarioApp.toUpperCase() === 'ADMINSAN' && !eliminar">Eliminar</v-btn>
          <v-btn color="error" @click.native="eliminarRegistro" v-if="eliminar">Confirmar eliminación</v-btn>
          <v-btn color="primary" v-on:click="nuevoRegistro()" v-if="disabledRegistro">Nuevo</v-btn>
          <v-btn color="primary" v-on:click="disabledRegistro=false" v-if="disabledRegistro">Editar</v-btn>
          <v-btn color="primary" @click.native="cerrar">Cerrar</v-btn>
          <v-btn color="primary" @click.native="guardar" v-if="!disabledRegistro">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td class="">{{ props.item.fila[2] }}</td>
      <td class="">{{ props.item.fila[3] }}</td>
      <td class="">{{ props.item.fila[4] }}</td>
      <td class="">{{ props.item.fila[5] }}</td>
      <td class="">{{ props.item.fila[7] }}</td>
      <td align="center">
        <v-tooltip bottom v-if="props.item.fila[0] !== 0">
          <v-icon
            slot="activator"
            @click="verRegistro(props.item)"
          >open_in_browser</v-icon>
          <span>Ver</span>
        </v-tooltip>
      </td>
    </template>
    <template slot="no-data">
      -
    </template>
  </v-data-table>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  props: ['login', 'tipoUsuario', 'usuarioApp', 'sedes'],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    disabledAsesor: false,
    validarAlumno: true,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    buscar: '',
    eliminar: false,
    headers: [
      { text: 'Código', value: 0 },
      { text: 'Nombre', value: 1 },
      { text: 'RUC', value: 2 },
      { text: 'Teléfono', value: 3 },
      { text: 'Correo', value: 4 },
      { text: 'Sede', value: 5 },
      { text: 'Ver', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    registro: {},
    grado: '',
    tiposColegio: [{'id': 'E', 'nombre': 'ESTATAL'}, {'id': 'P', 'nombre': 'PRIVADO'}],
    asesor: []
  }),
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: '',
        buscar: this.buscar
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegios&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0]}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegios&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.productosDetalle = {}
            if (item.fila[0] !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    editarRegistro (item) {
      this.disabledSede = false
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0]}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegios&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.disabledRegistro = false
            this.dialog = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.eliminar = false
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar () {
      this.cerrar()
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegios&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.verRegistro({fila: [datos.d.id]})
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            } else {
              alert(datos.m)
            }
          }
        })
    },
    actualizar () {
      let descendente = 0
      if (this.pagination.descending) {
        descendente = 1
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
    },
    eliminarRegistro (item) {
      if (!this.eliminar) {
        this.eliminar = true
        return
      }
      this.cerrar()
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': this.registro.id}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=colegios&accion=eliminar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.disabledRegistro = false
            this.eliminar = false
            this.dialog = false
            let descendente = 0
            if (this.pagination.descending) {
              descendente = 1
            }
            this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
          }
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Colegios.vue